interface IProps {
    onClickPrevTransactionBtn: () => void;
}

const ActivityItemInfo = ({ onClickPrevTransactionBtn }: IProps) => {
    return (
        <li className="transaction-info activity-area-last-item">
            <p className="activity-notice text-sm font-semibold">최근 20건의 기록만 노출됩니다.</p>
            <div className="history-button-wrapper">
                <button type="button" className="history-button text-sm font-medium" onClick={onClickPrevTransactionBtn}>
                    이전거래 보러가기
                    <img src="./images/box-arrow-icon.png" alt="이전거래 보러가기" className="box-arrow-icon" />
                </button>
            </div>
        </li>
    )
}

export default ActivityItemInfo;    